import "./Services.module.css";
import Navigation from "@/reusable_sections/Header";
import Solutions from "./sections/Solutions";
import Integration from "./sections/Integration";
import Framework from "./sections/Framework";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Navigation />
      <Solutions />
      <Integration />
      <Framework />
      <Footer />
    </div>;
}